import { useState } from 'react'
import { Box, Button, Link, TextField, Typography } from '@mui/material'
import logo from '../../logo.png'
import { ReferralCallerInfoResponse } from 'graphql/gen-types'

export interface ReferralCallerInfoAckCardProps {
  referralId: string
  centerName: string
  initialMode: 'acknowledge' | 'other'
  onSubmit: (response: ReferralCallerInfoResponse, reason?: string) => void
  submitting: boolean
}

export const ReferralCallerInfoAckCard = ({
  referralId,
  centerName,
  initialMode,
  onSubmit,
  submitting,
}: ReferralCallerInfoAckCardProps): JSX.Element => {
  const [mode, setMode] = useState<'acknowledge' | 'other'>(initialMode)
  const [reason, setReason] = useState('')

  return (
    <Box>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
        gap={2}
      >
        <Box>
          <Typography variant="h6" color="primary.main" fontWeight={600}>
            Caller Information
          </Typography>
          <Typography variant="body1" color="text.disabled">
            Referral{' '}
            <Box component="span" color="text.primary" fontWeight={700}>
              {referralId}
            </Box>{' '}
            sent to{' '}
            <Box component="span" color="text.primary" fontWeight={700}>
              {centerName}
            </Box>
            .
          </Typography>
        </Box>
        <Box
          component="img"
          src={logo}
          alt="resolvexLogo"
          sx={{ width: { xs: 64, sm: 96 } }}
        />
      </Box>

      {mode === 'acknowledge' ? (
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="body1">
            Please confirm you received this referral and will follow up with
            the caller.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            disabled={submitting}
            onClick={() => onSubmit(ReferralCallerInfoResponse.Acknowledge)}
          >
            Acknowledge
          </Button>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            required
            multiline
            minRows={3}
            label="Reason"
            fullWidth
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 1000 }}
            helperText={`${reason.length}/1000`}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            disabled={submitting || !reason.trim()}
            onClick={() =>
              onSubmit(ReferralCallerInfoResponse.Other, reason.trim())
            }
          >
            Submit
          </Button>
        </Box>
      )}

      <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
        <Link
          component="button"
          variant="body2"
          underline="hover"
          disabled={submitting}
          onClick={() => {
            if (!submitting) {
              setMode(mode === 'acknowledge' ? 'other' : 'acknowledge')
            }
          }}
        >
          {mode === 'acknowledge'
            ? 'Need to give a reason instead?'
            : 'Acknowledge instead'}
        </Link>
      </Box>
    </Box>
  )
}
